var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 py-2 lightgrey text-right flex-grow-1 flex-shrink-0",staticStyle:{"white-space":"nowrap"}},[_c('div',{staticClass:"body-1 font-weight-medium"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',{staticClass:"text-title-small"},[_vm._v(" "+_vm._s(_vm.subtext)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }